import { useState, useEffect,  useContext } from 'react';
import { StateContext, DispatchContext } from '../../../App';
import { FormattedMessage } from 'react-intl';
import { dispatchSideMenuToggle, dispatchSummaryToggle } from '../../../functions/functions';

import './SideMenu.css';
import settingsIcon from '../../../images/icons/settings-white.svg';
import plusIcon from '../../../images/icons/plus-white.svg';
import closeIcon from '../../../images/icons/x-black.svg';
import summaryIcon from '../../../images/icons/summary.svg';


const OvalButton = ({ buttonId, defaultMessage, activeButtonId, handleClick, isSummaryOpen }) => {
    const [ isActive, setIsActive ] = useState(false);
    useEffect(() => {
        buttonId === activeButtonId ? setIsActive (true) : setIsActive(false);
    },  [buttonId, activeButtonId]);

    return (
        isSummaryOpen  ? <button 
            className={isActive ? 'navbar-btn nb-s nb-active' : 'navbar-btn nb-s'}
            onClick={() => handleClick(buttonId)}
        >
            <FormattedMessage
                id={buttonId}
                defaultMessage={defaultMessage}
            />
        </button> : <button 
            className={isActive ? 'navbar-btn nb-active' : 'navbar-btn'}
            onClick={() => handleClick(buttonId)}
        >
            <FormattedMessage
                id={buttonId}
                defaultMessage={defaultMessage}
            />
        </button>
    )
};
const Navbar = ({buttons}) => {
    const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);
    const { isSideMenuOpen, sideMenuTabs, tab, isSummaryOpen } = appState.appSettings;
    const [ activeTab, setActiveTab ]               = useState(tab);
    const [ tabNote, setTabNote ]                   = useState('modify_note');  

    let sideMenuTabsArray = isSummaryOpen ? buttons : buttons.filter(tab => 
        sideMenuTabs.includes(tab.id)
    );
    const updateActiveTab = (buttonId) => {
        setActiveTab(buttonId);
        dispatch({
            type: 'SET_TAB',
            payload: buttonId
        })
    };

    const toggleSummary = () => {
        dispatchSummaryToggle(dispatch, false);
    };

    const toggleSideMenu = () => {
        dispatchSideMenuToggle(dispatch, !isSideMenuOpen);
    };

    useEffect(() => {
        if (!isSummaryOpen) {
            setTabNote(sideMenuTabsArray.filter(tab => {
                return tab.id === activeTab
            })[0].note);
        }
        
    }, [activeTab]);

    return (
        <>
            
            <div className='sidemenu-navbar'>
                {
                    isSummaryOpen ? null : <img 
                        className='settings-icon' 
                        alt='settings icon' 
                        src={settingsIcon}
                        onClick={() => isSideMenuOpen ? null : toggleSideMenu()}
                    />
                }
                <div className='navbar-tabs'>
                    {
                        sideMenuTabsArray.length > 0 ? sideMenuTabsArray.map((tab, _i) => {
                            return (
                                <OvalButton
                                    key={_i}
                                    buttonId={tab.id} 
                                    defaultMessage={tab.id}
                                    activeButtonId={activeTab}
                                    handleClick={updateActiveTab}
                                    isSummaryOpen={isSummaryOpen}
                                />
                            )
                        }) : null 
                    }
                </div>

                {
                    isSummaryOpen ? null : <img 
                        className='plus-icon' 
                        alt='close button icon' 
                        src={plusIcon}
                        onClick={() => toggleSideMenu()}
                    />
                }
            </div>

            <div className={isSummaryOpen ? 'sidemenu-note order1' : 'sidemenu-note'}>
                <div className='aligner'>
                    {
                        isSummaryOpen ? <img 
                            className='settings-icon' 
                            alt='summary icon'
                            src={summaryIcon} 
                        /> : null
                    }
                    {
                        isSummaryOpen ? null : <img 
                            className='close-icon' 
                            alt='close button icon' 
                            src={closeIcon}
                            onClick={() => toggleSideMenu()}
                        />
                    }
                    
                    {
                        isSummaryOpen ? <FormattedMessage 
                            id='summary_note'
                            defaultMessage='Composition summary'
                        /> : <FormattedMessage 
                            id={tabNote}
                            defaultMessage={tabNote}
                        />
                    }
                    
                </div>
                {
                    isSummaryOpen ? <img 
                        className='close-icon-summary' 
                        alt='close button icon' 
                        src={closeIcon}
                        onClick={() => toggleSummary()}
                    /> : null
                }
            </div>
        </>
    )
};

export default Navbar;